/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HelloResponse } from '../models/HelloResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HelloService {
    /**
     * 挨拶エンドポイント
     * 簡単な挨拶を返すエンドポイント。エラーの発生と待機時間の設定が可能。
     * @param shouldError
     * @param waitTime
     * @returns HelloResponse Successful Response
     * @throws ApiError
     */
    public static helloApiHelloGet(
        shouldError?: (boolean | null),
        waitTime?: (number | null),
    ): CancelablePromise<HelloResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hello',
            query: {
                'should_error': shouldError,
                'wait_time': waitTime,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
